<template>
    <div class="page products"  @scroll="pageScroll" ref="page">
        <div class="pageContainer">
            <div class="container">
                <h2 class="d-flex justify-content-between align-items-center">
                    <img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)" alt="back">
                    <span>{{ $t('favorites.Favorites') }}</span>
                    <span style="width: 35px"></span>
                </h2>
                <div v-if="Object.keys(liked).length" class="position-relative">
                    <!--<div class="text-right smallText">
                        Showing {{ (searchResults.per_page * searchResults.current_page) }} of {{searchResults.total}}
                        Recipes
                    </div>-->
                    <transition-group
                        name="zoom"
                        tag="div"
                        class="list"
                    >
                        <RecipeListItem
                            v-for="(recipe, index) in liked"
                            v-if="startAnimation"
                            :key="recipe.id"
                            :recipe="recipe"
                            style="animation-duration: 1s"
                        ></RecipeListItem>
                    
                    </transition-group>
                    
                    <!--<div
                        style="position: absolute; bottom: 1000px;"
                        v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
                        v-if="searchResults.current_page < searchResults.last_page"
                    ></div>
            
                    <div class="text-center">LOADING</div>-->
                </div>
                <h3 v-else class="text-center my-5">{{ $t('favorites.You currently have no favorite recipes') }}</h3>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState} from "vuex";
    import pageMixin from "../mixins/page";

    import RecipeListItem from "../components/RecipeListItem"

    export default {
        name: 'Favorites',
        mixins: [pageMixin],
        components: {RecipeListItem},
        mounted(){
            this.changePageTitle("Your Favorite Cocktail Recipes | ABM Cocktail Pro");
        },
        computed: {
            ...mapState("recipe", ["liked"])
        },
    }
</script>


